import React from "react"

function IconLaptop({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="laptop"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-laptop"
      {...props}
    >
      <path
        d="M19.636 3.71c.91 0 1.658.696 1.739 1.586l.007.159v10.253l1.527.001c.412 0 .713.373.646.764l-.025.098-.842 2.526a1.746 1.746 0 0 1-1.497 1.187l-.16.007H2.969a1.746 1.746 0 0 1-1.598-1.044l-.058-.15-.842-2.526a.655.655 0 0 1 .52-.854l.1-.008 1.528-.001V5.455c0-.91.697-1.659 1.587-1.739l.159-.007h15.272zM22 17.017H2l.555 1.665c.04.123.132.218.246.265l.09.027.078.007h18.064a.436.436 0 0 0 .382-.226l.032-.073.554-1.665zm-2.364-12H4.364c-.211 0-.387.15-.428.349l-.009.088v10.254h16.146V5.455c0-.181-.11-.336-.267-.403l-.082-.025-.088-.009z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconLaptop
